"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgSelectAvailAdminCtl = /** @class */ (function (_super) {
    __extends(DlgSelectAvailAdminCtl, _super);
    function DlgSelectAvailAdminCtl() {
        return _super.call(this, true) || this;
    }
    DlgSelectAvailAdminCtl.prototype.ResetData = function () {
        this.DATA = {
            onClose: null,
            onSelect: null,
            visible: false
        };
    };
    DlgSelectAvailAdminCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSelectAvailAdminCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSelectAvailAdminCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectAvailAdminCtl.prototype, "onClose", {
        get: function () {
            return this.DATA.onClose;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectAvailAdminCtl.prototype.SetOnCloseClick = function (callback) {
        this.DATA.onClose = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectAvailAdminCtl.prototype, "OnSelect", {
        get: function () {
            return this.DATA.onSelect;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectAvailAdminCtl.prototype.SetOnSelectClick = function (callback) {
        this.DATA.onSelect = callback;
        this.Update();
        return this;
    };
    return DlgSelectAvailAdminCtl;
}(BaseController_1.BaseController));
exports.DlgSelectAvailAdminCtl = DlgSelectAvailAdminCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgSelectAvailAdminCtl.ts
// module id = 893
// module chunks = 0